






























import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "lodash";

import { WorkshopModel, WorkshopFormLookups } from "@/core/models";
import { WorkshopService } from "@/core/services";
import { BaseFormComponent, InputSelectCpt, SubmitButtonCpt } from "@/core/components";

@Component({
  components: {
    InputSelectCpt,
    SubmitButtonCpt,
  },
})
export default class EditWorkshopFormCpt extends BaseFormComponent {
  @Prop({ default: false }) loading: boolean;
  @Prop() workshopId?: number;

  lookups = {} as WorkshopFormLookups;
  model: WorkshopModel = {
    id: undefined,
    eventDate: new Date(),
    location: "",
    regionId: undefined,
  } as any;

  async created() {
    await this.initializeLookups();
    await this.initializeModel();
  }

  async onSubmitForm() {
    this.workshopId ? await WorkshopService.putWorkshop(this.model) : await WorkshopService.postWorkshop(this.model);
    this.$emit("onSave");
  }

  private async initializeLookups() {
    this.lookups = await WorkshopService.getWorkshopFormLookups();
  }

  private async initializeModel() {
    if (this.workshopId) {
      const model = await WorkshopService.getWorkshop(this.workshopId);
      _.extend(this.model, model);
    }
  }
}
